<!-- 多张图片上传组件 -->
<template id="images-upload">
	<div class="images-upload-list">
		<el-upload
			list-type="picture-card"
			:headers="headers"
			:on-success="onSuccess"
			:file-list="fileList"
			:on-preview="handlePictureCardPreview"
			:on-remove="onRemove"
			accept=".png, .jpg, .jpeg, .webp"
			:disabled="disabled"
			:limit="limit"
			:on-exceed="onExceed"
			:before-upload="beforeAvatarUpload"
			:http-request="handleUpload"
		>
			<i slot="default" class="el-icon-plus" />
		</el-upload>
		<div
			v-show="dialogVisible"
			class="image-preview-modal"
			@click.self="close"
		>
			<div class="image-preview-modal-body">
				<img :src="dialogImageUrl" alt>
			</div>
		</div>
	</div>
</template>

<script>
import { configUrl } from '@/lib/configUrl.js'
import Axios from 'axios'

export default {
	name: 'ImagesUpload',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: Array,
			default: function() {
				return []
			}
		},
		limit: {
			type: Number,
			default: 6
	  },
		maxSize: {
			type: Number,
			default: 10
		},
		payRequestId: {
			type: String,
			default: ''
		},
		action: {
			type: String,
			default: configUrl + '/merchant/acquirer/file/kbankFileupload'
		}
	},
	data: function() {
		return {
			domain: this.getMerchantFilesUrl(),
			srcList: [],
			loading: false,
			fileList: [],
			imageList: this.value || [],
			fileName: '',
			dialogImageUrl: '',
			dialogVisible: false,
			headers: {
				accessToken: window.sessionStorage.getItem('accessToken')
			}
		}
	},

	watch: {
		value: {
			handler: function(val, oldVal) {
				if (val && val.length > 0) {
					var imags = val.filter((item) => /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(item.fileName))
					console.log(12, imags)
					var fileList = imags.map((item) => {
						const url = this.fetchImg(item.fileName)

						return {
							name: item.fileName,
							url: url
						}
					})

					this.fileList = fileList || []
					this.imageList = val
				}
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		handleUpload(param) {
			const formData = new FormData()
			formData.append('file', param.file) // 'file' 是后端接收的字段名
			formData.append('payRequestId', this.payRequestId)

			Axios({
				method: 'post',
				url: this.action,
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
					accessToken: window.sessionStorage.getItem('accessToken')
				}
			}).then(res => {
				if (res.data.code === 200) {
					const { fileId, fileName } = res.data.data
					const url = this.fetchImg(fileName)
					const uploadedFile = {
						name: fileName,
						url: url
					}

					this.fileList.push(uploadedFile)

					this.imageList.push({ fileName, filePath: fileName, type: 'IMG', fileId: fileId })

					this.$emit('input', this.imageList)
				} else {
					this.$message.error(this.$t('chargeBack.form.uploadFailed'))
				}
			}).catch(err => {
				console.error(err)
				this.$message.error(this.$t('chargeBack.form.uploadFailed'))
			})
		},
		// onSuccess(response, file, fileList) {
		// 	this.loading = false
		// 	const { code = '', data = {}} = response
		// 	const { fileName } = data
		// 	debugger
		// 	if (code !== 200 && fileName) {
		// 		this.$message.error(this.$t('chargeBack.form.uploadFailed'))
		// 	} else {
		// 		this.fileList.push({
		// 			name: fileName,
		// 			url: `${this.domain}/selectFile/${fileName}`
		// 		})
		// 		this.imageList.push({ fileName, filePath: fileName, type: 'IMG' })
		// 		this.$emit('input', this.imageList)
		// 	}
		// },
		// 文件数量超出最大限制
		onExceed(files, fileList) {
			if (fileList.length >= this.limit) {
				this.$message.error(this.$t('chargeBack.form.imageLimited', { max: this.limit }))
			}
		},
		beforeAvatarUpload(file) {
			const isLt20M = file.size / 1024 / 1024 < this.maxSize
			if (!isLt20M) {
				this.$message.error(this.$t('chargeBack.form.uoloadLimited', { max: this.maxSize }))
			}

			return isLt20M
		},

		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url
			this.srcList = file.url
			this.dialogVisible = true
		},

		close() {
			this.dialogVisible = false
		},
		onRemove(file, fileList) {
			var imageList = this.imageList
			var _imageList = imageList.filter(function(item, index) {
				return file.url.indexOf(item.fileName) === -1
			})

			this.imageList = _imageList
			this.$emit('input', this.imageList)
		}
	}
}
</script>

<style lang="scss" scoped>
.image-preview-modal {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.7);
	z-index: 4000;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
}

.image-preview-modal-body {
	background-color: #fff;
	display: inline-block;
	padding: 30px;
	overflow: auto;
	max-width: 90%;
	max-height: 90%;
}

.image-preview-modal-body img {
	width: auto;
}

.images-upload-list {
	display: flex;

	// padding-top: 14px;
}

.el-upload.el-upload--picture-card {
	display: inline-block;
}

.el-upload--picture-card i {
	margin-top: 50%;
	transform: translateY(-50%);
}
</style>
